import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import VueLazyload from "vue-lazyload";
import { Search, Icon, Toast, Loading, Actionsheet, Popup, Overlay } from "vant";
// import Mint, { IndexList, IndexSection } from "mint-ui";
import * as constant from "@/utils/constant";
import { BFD_checkApp } from "@/utils/bfdApp.js";
import { checkXcx } from "@/utils/checkXcx.js";
import { setCookie } from "@/utils/func.js";
import { getQueryString } from "@/utils";

import injectionWindow from '@/utils/lang/index';
import { BFD_checkOtherApp, initOtherSDK } from "@/utils/bfdOtherApp";
import { initAddressDF } from "dflocationsdk";
// import vConsole from '@/assets/js/vconsole.js';


function getQueryStringByUrl(name, url) {
  let search = window.location.search
  if (url) {
    const searchIndex = url.indexOf('?')
    if (searchIndex > -1) {
      search = url.slice(searchIndex)
    }
  }
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return ''
}
function checkMiniCookie() {
  const url = (decodeURIComponent(getQueryString("return_url") || getQueryString('returnUrl')))
  if (checkXcx() && getQueryStringByUrl("from", url) === "mini" && url.includes('test05')) {
    // 如果是小程序,回写cookie
    const { hostname } = window.location; // m.test03.com
    const position = hostname.indexOf("."); // 1
    const domain = hostname.slice(position); // .test03.com
    setCookie("dfflone", null, 604800, "/", domain);
    setCookie("dfflone", null, 604800, "/", hostname);
    const dfflone = getQueryStringByUrl("dfflone", url) || "";
    setCookie("dfflone", dfflone, 604800, "/", domain);
    setCookie("dfflone", dfflone, 604800, "/", hostname);
  }
}
// checkMiniCookie()
initAddressDF(false, null, false, '', true)
try {
  let isBFDApp = BFD_checkApp();
  Vue.prototype.isBFDApp = isBFDApp;
  Vue.prototype.checkXcx = checkXcx();
  console.log('componentDidMount-isBFDApp', isBFDApp)
  if (isBFDApp) {
    loadFUNJS();
    window.df_back = function () {
      let b = false;
      if (document.referrer) {
        window.history.back()
        b = true;
      }
      return b
    }
  }

  if (BFD_checkOtherApp()) {
    initOtherSDK()
  }
} catch (e) {
  console.log('初始化loadFUNJS失败', e)
}
Vue.use(Search);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Actionsheet);
Vue.use(Popup);
Vue.use(Overlay);
// Vue.use(vConsole);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error:
    "data:image/gif;base64,R0lGODlhCgAKAIAAAO7u7gAAACH5BAAAAAAALAAAAAAKAAoAAAIIhI+py+0PYysAOw==",
  loading:
    "data:image/gif;base64,R0lGODlhCgAKAIAAAO7u7gAAACH5BAAAAAAALAAAAAAKAAoAAAIIhI+py+0PYysAOw==",
  attempt: 1
});
// Vue.use(Mint);

// Vue.component(IndexList.name, IndexList);
// Vue.component(IndexSection.name, IndexSection);

Vue.prototype.union_isBilingual = false;
injectionWindow();
Vue.prototype.TLang = window.TLang;
Vue.prototype.ReplaceText = window.ReplaceText;

Vue.config.productionTip = false;
Vue.prototype.constant = constant;

window.app1 = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
